export default __webpack_public_path__ + "static/save-a-funnel-light-mode-b4a286829e1e6736480d4b2d47bb5733.mp4";